import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gerenciador',
  templateUrl: './gerenciador.component.html',
  styleUrls: ['./gerenciador.component.css']
})
export class GerenciadorComponent implements OnInit {

  constructor(private router: Router) {
    if (sessionStorage.getItem("logado") == JSON.stringify(true)) {
      this.router.navigateByUrl("/gerenciador/inicio");
    }
  }

  ngOnInit() {
    const logado = sessionStorage.getItem("logado") || false;
    if (!sessionStorage.getItem("usuario")) {
       this.router.navigate(["login"]);
    } else if (!logado) {
      sessionStorage.setItem("logado", JSON.stringify(true));
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/gerenciador/gerenciador.component.ts